import actions from "actions";
import axios from "axios";
import constants from "constants";
import _ from "lodash";
import moment from "moment";
import PropTypes from "prop-types";
import React, { Component } from "react";
import { connect } from "react-redux";
import inputFormatter from "services/userInputFormatter";
import validator from "services/validator";
import shortid from "shortid";
import StudyGroupSuperhostAddWebinarForm from "./StudyGroupSuperhostAddWebinarForm";
import { loadSponsorsSuggestionsSaga } from "../../../actions/suggestions";
import { toast } from "react-toastify";

const {
  CPD_STATUSES,
  REF_TYPES,
  CREATE_WEBINAR_SAGA,
  MODAL_TYPE_WEBINAR,
  API_ADMIN_WEBINARS,
} = constants;

const {
  setTempWebinar,
  cleanErrors,
  showModal,
  adminPostAssignedUsersSaga,
  // getSponsorsRepresentatives,
  addValidateError,
} = actions;

class StudyGroupSuperhostAddWebinar extends Component {
  static propTypes = {
    cleanErrors: PropTypes.func,
    dispatch: PropTypes.func,
    errors: PropTypes.obj,
    errorsFrontend: PropTypes.obj,
  };

  constructor(props) {
    super(props);
    let tempWebinar = {};

    if (
      props.location.state &&
      props.location.state.from === "addUsersWebinar"
    ) {
      tempWebinar = {
        ...props.tempWebinar,
        ...{
          assigned_ids:
            (props.tempWebinar && props.tempWebinar.assigned_ids) || [],
          assigned_users: props.users,
        },
      };
    }

    this.state = {
      webinar: {
        assigned_ids: [],
        assigned_users: [],
        user_sponsor_ids: [],
        is_sponsored: false,
        sponsorship_value: 0,
        // sponsor_representative_id: "",
        start_date: moment().set("seconds", 0),
        end_date: moment().set("seconds", 0),
        webinar_title: "",
        search_disciplines: [],
        sponsor_ids: [],
        for_event: false,
        generate_qrcode: false,
        status: "published",
        int_cpd_points: "",
        ext_cpd_points: "",
        cpd_points: "external",
        document: null,
        pptDocumentType: "",
        evaluationSummaryType: "",
        gms_study_days: "",
        cpd_status: CPD_STATUSES.granted,
        ref_type: REF_TYPES.ICGP,
        icgp_ref: "",
        ipna_ref: "",
        rcpi_ref: "",
        audio_link: "",
        webinar_type: "online",
        join_url: "",
        spd_quizzes_attributes: [
          { __id: shortid.generate(), question: "", correct: false },
        ],
        experts_attributes: [
          {
            __id: shortid.generate(),
            name: "",
            expert_type: "",
            location: "",
            expert_avatar_url: "",
            numeration: "",
            presentation_title: "",
          },
        ],
        ...tempWebinar,
      },
    };
    this.onDragEnd = this.onDragEnd.bind(this);
  }

  componentWillMount() {
    this.props.cleanErrors();
    this.props.adminPostAssignedUsersSaga(this.state.webinar.assigned_ids);
    // this.props.getSponsorsRepresentatives();
    this.props.loadAllSponsors();
  }

  handleAudioLink = (audio_link) =>
    this.setState((state) => ({ webinar: { ...state.webinar, audio_link } }));

  onConsultantOrHD = (allCounties) => {
    let newWebinar = {};

    const selectedAllCounties = _.isEqual(
      allCounties,
      this.state.webinar.counties
    );
    if (!this.state.webinar.counties || !selectedAllCounties) {
      newWebinar = {
        ...newWebinar,
        ...{ counties: allCounties.map((county) => county) },
      };
    }

    if (
      this.state.webinar.ext_cpd_points !== 0 &&
      this.state.webinar.int_cpd_points !== 0
    ) {
      newWebinar = {
        ...newWebinar,
        ...{ ext_cpd_points: 0, int_cpd_points: 0 },
      };
    }

    if (!_.isEmpty(newWebinar)) {
      this.setState({ webinar: { ...this.state.webinar, ...newWebinar } });
    }
  };

  onFieldChange = (e) => {
    const fieldValue = [...e.target.value];
    let input = inputFormatter.formatField(e.target.name, e.target.value);

    const webinarData = {
      ...this.state.webinar,
      ...{
        [e.target.name]: input,
      },
    };
    if (e.target.name === "user_types") {
      const ipnaMemberIndex = fieldValue.indexOf(8);

      if (ipnaMemberIndex > -1) {
        fieldValue[ipnaMemberIndex] = 2;
      }

      this.props.loadDisciplines(fieldValue);
    }

    this.setState({ webinar: webinarData });
  };

  onSponsorChange = (sponsor_ids) => {
    this.onFieldChange({
      target: {
        name: "sponsor_ids",
        value: (sponsor_ids || []).map((sponsor) => sponsor.value),
      },
    });
  };

  onSelectChangeDisciplineWebinar = (disciplines) => {
    this.onFieldChange({
      target: {
        name: "disciplines",
        value: (disciplines || []).map(
          (discipline) => discipline.value || discipline.id
        ),
      },
    });
  };
  onSelectChangeDisciplineWebinarSearch = (disciplines) => {
    this.onFieldChange({
      target: {
        name: "search_disciplines",
        value: (disciplines || []).map(
          (discipline) => discipline.value || discipline.id
        ),
      },
    });
  };

  handleSponsorshipChange = (value) =>
    this.setState((state) => ({
      webinar: { ...state.webinar, is_sponsored: value },
    }));

  onCpdPointsChange = (e) => {
    const input = inputFormatter.formatField(e.target.name, e.target.value);
    const cpds = {
      ...(this.state.webinar.cpd_points == "internal"
        ? {
            [e.target.name]: input,
            ext_cpd_points: 0,
          }
        : {}),
      ...(this.state.webinar.cpd_points == "external"
        ? {
            [e.target.name]: input,
            int_cpd_points: 0,
          }
        : {}),
      ...(this.state.webinar.cpd_points == "both"
        ? {
            [e.target.name]: input,
          }
        : {}),
    };
    const webinarData = { ...this.state.webinar, ...cpds };

    this.setState({ webinar: webinarData });
  };

  onCpdTypeChange = (e) => {
    const value = e.target.value;
    this.setState({
      webinar: {
        ...this.state.webinar,
        cpd_status: e.target.value,
        ...(value !== CPD_STATUSES.granted
          ? {
              ext_cpd_points: 0,
              int_cpd_points: 0,
              icgp_ref: "",
            }
          : {}),
      },
    });
  };

  // handleSponsorRepresentativeChange = (id) =>
  //   this.setState({
  //     webinar: {
  //       ...this.state.webinar,
  //       sponsor_representative_id: id,
  //     },
  //   });

  onCertificateRefChange = (e) => {
    const value = e.target.value;
    let refType;

    if (value === REF_TYPES.ICGP) {
      refType = {
        icgp_ref: this.state.webinar.icgp_ref || "",
      };
    } else if (value === REF_TYPES.RCPI) {
      refType = {
        rcpi_ref: this.state.webinar.rcpi_ref || "",
      };
    } else {
      refType = {
        ipna_ref: this.state.webinar.ipna_ref || "",
      };
    }

    this.setState({
      webinar: {
        ...this.state.webinar,
        ref_type: e.target.value,
        ...refType,
      },
    });
  };

  onQuizAdd = () => {
    this.setState({
      webinar: {
        ...this.state.webinar,
        ...{
          spd_quizzes_attributes: [
            ...this.state.webinar.spd_quizzes_attributes,
            ...[{ question: "", correct: false, __id: shortid.generate() }],
          ],
        },
      },
    });
  };

  onQuizRemove = (__id) => {
    const quizzes = this.state.webinar.spd_quizzes_attributes.filter(
      (quiz) => quiz.__id != __id
    );
    this.setState({
      webinar: {
        ...this.state.webinar,
        ...{
          spd_quizzes_attributes: quizzes,
        },
      },
    });
  };

  onQuizChange = (__id, field, value) => {
    let cpdQuiz = this.state.webinar.spd_quizzes_attributes.slice();
    let quiz = cpdQuiz.find((webinar) => webinar.__id == __id);
    quiz[field] = value;
    this.setState({
      webinar: {
        ...this.state.webinar,
        ...{
          spd_quizzes_attributes: cpdQuiz,
        },
      },
    });
  };

  // Expert CRUD
  onExpertAdd = () => {
    this.setState({
      webinar: {
        ...this.state.webinar,
        ...{
          experts_attributes: [
            ...this.state.webinar.experts_attributes,
            ...[
              {
                name: "",
                type: "",
                location: "",
                avatar: "",
                __id: shortid.generate(),
              },
            ],
          ],
        },
      },
    });
  };

  onExpertRemove = (__id) => {
    const experts = this.state.webinar.experts_attributes.filter(
      (expert) => expert.__id != __id
    );
    this.setState({
      webinar: {
        ...this.state.webinar,
        ...{
          experts_attributes: experts,
        },
      },
    });
  };

  onExpertChange = (__id, field, value) => {
    let experts = this.state.webinar.experts_attributes.slice();
    let expert = experts.find((webinar) => webinar.__id == __id);
    expert[field] = value;
    this.setState({
      webinar: {
        ...this.state.webinar,
        ...{
          experts_attributes: experts,
        },
      },
    });
  };

  cpdPointsFields = () => {
    const { cpd_points, cpd_status } = this.state.webinar;
    if (cpd_status !== CPD_STATUSES.granted) {
      return [];
    }
    switch (cpd_points) {
      case "external":
        return ["ext_cpd_points"];
      case "internal":
        return ["int_cpd_points"];
      case "both":
        return ["int_cpd_points", "ext_cpd_points"];
      default:
        return [];
    }
  };

  onSubmit = async () => {
    try {
      const { webinar } = this.state;

      console.log("webinar", webinar);

      const isCertificateOfParticipation =
        webinar.ref_type === REF_TYPES.CERTIFICATE_OF_PARTICIPATION;

      const isCustomCertificate = isCertificateOfParticipation;

      if (
        !isCustomCertificate &&
        webinar.spd_quizzes_attributes.filter(
          (e) => !!e.question && !e._destroy
        ).length < 10 &&
        webinar.cpd_status != "not_applicable" &&
        webinar.cpd_status != "applied_for"
      ) {
        toast.error("CPD Quiz should contain >= 10 questions");
        return;
      }

      const formdata = getFormData(webinar, this.props.params.id);
      await axios.post(API_ADMIN_WEBINARS, formdata);
      this.props.router.push(`/groups/${this.props.params.id}/webinars/all`);
    } catch (error) {
      console.log("error", { error });
      // this.props.dispatch(
      //   addValidateError(
      //     CREATE_WEBINAR_SAGA,
      //     error.response.data.error_messages
      //   )
      // );
    }
  };

  goToAddUsersPage = () => {
    this.props.setTempWebinar(this.state.webinar);
    this.props.router.push(
      `/groups/${this.props.params.id}/webinars/new/addUsers`
    );
  };

  showUsersModal = (additional = {}) => {
    this.props.showUsersModal(
      {
        users: this.props.users,
      },
      additional
    );
  };

  reorder(list, startIndex, endIndex) {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
  }

  onDragEnd(result) {
    if (!result.destination) {
      return;
    }

    const reorder = (list, startIndex, endIndex) => {
      const result = Array.from(list);
      const [removed] = result.splice(startIndex, 1);
      result.splice(endIndex, 0, removed);

      return result;
    };

    const speakers = reorder(
      this.state.webinar.experts_attributes,
      result.source.index,
      result.destination.index
    ).map((speaker, index) => {
      speaker.numeration = index + 1;
      return speaker;
    });

    this.setState({
      ...this.state,
      webinar: {
        ...this.state.webinar,
        experts_attributes: speakers,
        experts: speakers.filter((speaker) => speaker.expert_type),
      },
    });
  }

  handleSponsorShipValueChange = (value) =>
    this.setState((state) => ({
      webinar: { ...state.webinar, sponsorship_value: value },
    }));

  onWebinarTypeChange = (e) => {
    const webinarData = {
      ...this.state.webinar,
      ...{
        webinar_type: e.target.value,
      },
    };

    this.setState({ webinar: webinarData });
  };

  onDateChange = (field, value) => {
    const webinarData = {
      ...this.state.webinar,
      ...{
        [field]: value,
      },
    };
    this.setState({ webinar: webinarData });
  };

  render() {
    const { errors, errorsFrontend } = this.props;

    // const sponsorRepresantiveData = sponsorRepresantive
    //   ? sponsorRepresantive.data
    //   : [];

    return (
      <main className="site--width clearfix-c">
        <StudyGroupSuperhostAddWebinarForm
          onFieldChange={this.onFieldChange}
          webinar={this.state.webinar}
          onQuizAdd={this.onQuizAdd}
          onQuizChange={this.onQuizChange}
          onSubmit={this.onSubmit}
          onQuizRemove={this.onQuizRemove}
          errors={validator.formatErrors(errors, errorsFrontend)}
          cpdPointsFields={this.cpdPointsFields()}
          onCpdPointsChange={this.onCpdPointsChange}
          onCpdTypeChange={this.onCpdTypeChange}
          goToAddUsersPage={this.goToAddUsersPage}
          showUsersModal={this.showUsersModal}
          onAssignedUsersChange={this.onAssignedUsersChange}
          sponsorsOptions={this.props.sponsors}
          onConsultantOrHD={this.onConsultantOrHD}
          onCertificateRefChange={this.onCertificateRefChange}
          onExpertAdd={this.onExpertAdd}
          onExpertRemove={this.onExpertRemove}
          onExpertChange={this.onExpertChange}
          onAttachmentChange={this.onAttachmentChange}
          pptDocumentType={this.state.webinar.pptDocumentType}
          evaluationSummaryType={this.state.webinar.evaluationSummaryType}
          disciplines={this.props.disciplines}
          onSelectChangeDiscipline={this.onSelectChangeDisciplineWebinar}
          onSelectChangeDisciplineSearch={
            this.onSelectChangeDisciplineWebinarSearch
          }
          search_disciplines={this.props.search_disciplines}
          onDragEnd={this.onDragEnd}
          handleAudioLink={this.handleAudioLink}
          handleSponsorshipChange={this.handleSponsorshipChange}
          // sponsorsRepresentative={sponsorRepresantiveData}
          // handleSponsorRepresentativeChange={
          //   this.handleSponsorRepresentativeChange
          // }
          sponsorship_value={this.state.webinar.sponsorship_value}
          handleSponsorShipValueChange={this.handleSponsorShipValueChange}
          onWebinarTypeChange={this.onWebinarTypeChange}
          onDateChange={this.onDateChange}
          onSponsorChange={this.onSponsorChange}
        />
      </main>
    );
  }
}

function mapStateToProps(state) {
  return {
    tempWebinar: state.webinars.tmp,
    users: state.users.assignedUsers.values,
    // sponsorRepresantive: state.users.sponsorRepresantive,
    errors: state.errors[CREATE_WEBINAR_SAGA],
    errorsFrontend: state.errors[`${CREATE_WEBINAR_SAGA}_FRONTEND`],
    search_disciplines: state.disciplines.search.values,
    count: state.disciplines.list.count,
    total_pages: state.disciplines.list.total_pages,
    page: state.disciplines.list.page,
    query: state.disciplines.list.query,
    role: state.users.user.role,
    sponsors: state.suggestions.sponsor.values,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    setTempWebinar: (webinar) => dispatch(setTempWebinar(webinar)),
    cleanErrors: () => dispatch(cleanErrors(CREATE_WEBINAR_SAGA)),
    showUsersModal: (contentProps) =>
      dispatch(showModal(MODAL_TYPE_WEBINAR, contentProps)),
    adminPostAssignedUsersSaga: (assigned_ids, onlyAssigned = true) =>
      dispatch(
        adminPostAssignedUsersSaga(assigned_ids, onlyAssigned, 1, {}, 500)
      ),
    dispatch: dispatch,
    loadAllSponsors: () => dispatch(loadSponsorsSuggestionsSaga()),
    // getSponsorsRepresentatives: () => dispatch(getSponsorsRepresentatives()),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StudyGroupSuperhostAddWebinar);

const getFormData = (webinar, group_id) => {
  const {
    webinar_title,
    audio_link,
    status,
    cpd_status,
    cpd_points,
    int_cpd_points,
    ext_cpd_points,
    assigned_ids,
    icgp_ref,
    ipna_ref,
    ref_type,
    rcpi_ref,
    spd_quizzes_attributes,
    experts_attributes,
    gms_study_days,
    is_sponsored,
    sponsorship_value,
    // sponsor_representative_id,
    search_disciplines,
    webinar_type,
    start_date,
    end_date,
    join_url,
    sponsor_ids,
  } = webinar;

  const formdata = new FormData();

  const isCertificateOfParticipation =
    ref_type === REF_TYPES.CERTIFICATE_OF_PARTICIPATION;

  const isCustomCertificate = isCertificateOfParticipation;

  formdata.append("webinar[group_id]", group_id);
  formdata.append("webinar[webinar_title]", webinar_title);
  formdata.append("webinar[webinar_type]", webinar_type);
  formdata.append("webinar[status]", status);
  formdata.append("webinar[cpd_status]", cpd_status);

  if (!isCustomCertificate) {
    formdata.append("webinar[cpd_points]", cpd_points);
    formdata.append("webinar[int_cpd_points]", int_cpd_points);
    formdata.append("webinar[ext_cpd_points]", ext_cpd_points);
  }

  if (webinar_type === "audio") {
    formdata.append("webinar[audio_link]", audio_link);
  }

  if (webinar_type === "online") {
    formdata.append("webinar[start_date]", start_date);
    formdata.append("webinar[end_date]", end_date);
    formdata.append("webinar[join_url]", join_url);
  }

  if (assigned_ids.length) {
    for (const id of assigned_ids) {
      formdata.append("webinar[assigned_ids][]", id);
    }
  }

  if (sponsor_ids.length) {
    for (const id of sponsor_ids) {
      formdata.append("webinar[sponsor_ids][]", id);
    }
  }

  if (search_disciplines.length) {
    for (const id of search_disciplines) {
      formdata.append("webinar[search_discipline_ids][]", id);
    }
  }

  formdata.append("webinar[icgp_ref]", icgp_ref);
  formdata.append("webinar[ipna_ref]", ipna_ref);
  formdata.append("webinar[ref_type]", ref_type);
  formdata.append("webinar[rcpi_ref]", rcpi_ref);
  // formdata.append("webinar[evaluation_summary]", evaluation_summary); next
  const quizz = spd_quizzes_attributes.filter(({ question }) => question);
  if (quizz.length) {
    for (const { question, correct } of quizz) {
      formdata.append("webinar[spd_quizzes_attributes[]question]", question);
      formdata.append("webinar[spd_quizzes_attributes[]correct]", correct);
    }
  }

  const expert = experts_attributes.filter(({ name }) => name);
  if (expert.length) {
    for (const {
      name,
      expert_type,
      location,
      expert_avatar_url,
      numeration,
      presentation_title,
    } of expert) {
      formdata.append("webinar[experts_attributes[]name]", name);
      formdata.append("webinar[experts_attributes[]location]", location);
      formdata.append("webinar[experts_attributes[]expert_type]", expert_type);
      formdata.append(
        "webinar[experts_attributes[]presentation_title]",
        presentation_title
      );
      formdata.append("webinar[experts_attributes[]numeration]", numeration);
      formdata.append("webinar[experts_attributes[]avatar]", expert_avatar_url);
    }
  }

  formdata.append("webinar[gms_study_days]", gms_study_days);
  if (is_sponsored) {
    formdata.append("webinar[is_sponsored]", is_sponsored);
    formdata.append("webinar[sponsorship_value]", sponsorship_value);
    // formdata.append(
    //   "webinar[sponsor_representative_id]",
    //   sponsor_representative_id
    // );
  }

  return formdata;
};



// WEBPACK FOOTER //
// ./src/components/StudyGroupSuperhost/StudyGroupSuperhostAddWebinar/index.jsx